export { closeThread } from '../_internal/clients/closeThread';